module.exports = __webpack_public_path__ + "static/media/008-clown.cfac8757.svg";